import { Button, Stack, Tab, Tabs, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react'
import axios from 'axios';
import Card from "../components/Card";
import { model, fblink } from '../config/config';
import MenuItem from '@mui/material/MenuItem';


function Search() {
	
  const [type, setType] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [content, setContent] = useState([]);
  const [lang, setLang] = useState("");
  
  const fetchSearch = async () => {	
	
	let searchtype;
	if (type === 0)
		searchtype = "name";
	if (type === 1)
		searchtype = "author";
	if (type === 2)
		searchtype = "language";
	
    const { data } = await axios.get(`${fblink}/watchface/${model}.json?orderBy="${searchtype}"&startAt="${type === 2 ? lang : searchText}"&endAt="${type === 2 ? lang : searchText}"&limitToFirst=50`);
	
	
	if(data != null){
		let arrayOfObjects = Object.keys(data).map(key => {
			let ar = data[key]
			ar.key = key
			return ar})
		
		setContent(arrayOfObjects);
	}else{
		setContent([]);
	}
	
	localStorage.setItem("attempts", "0")
	
  }
  
  const langlist = [
	  {
		value: 'en',
		label: 'English',
	  },
	  {
		value: 'de',
		label: 'German',
	  },
	  {
		value: 'es',
		label: 'Spanish',
	  },
	  {
		value: 'fr',
		label: 'French',
	  },
	  {
		value: 'it',
		label: 'Italian',
	  },
	  {
		value: 'hu',
		label: 'Hungarian',
	  },
	  {
		value: 'pl',
		label: 'Polish',
	  },
	  {
		value: 'pt',
		label: 'Portuguese',
	  },
	  {
		value: 'ru',
		label: 'Russian',
	  },
	  {
		value: 'tr',
		label: 'Turkish',
	  },
	  {
		value: 'vi',
		label: 'Vietnamese',
	  },
	  {
		value: 'cz',
		label: 'Czech',
	  },
	  {
		value: 'ca',
		label: 'Catalan',
	  },
	  {
		value: 'el',
		label: 'Greek',
	  },
	  {
		value: 'zh',
		label: 'Chinese',
	  },
	  {
		value: 'da',
		label: 'Danish',
	  },
	  {
		value: 'uk',
		label: 'Ukrainian',
	  },
	  {
		value: 'sk',
		label: 'Slovak',
	  },
	  {
		value: 'ja',
		label: 'Japanese',
	  },
	  {
		value: 'multilingual',
		label: 'Multilingual',
	  },
	];

  useEffect(() => {
    window.scroll(0, 0);
    fetchSearch();   
  }, [type])
  return (
    <div className='container' style={{ padding: "64px 1vw 64px 1vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
      Search Amazfit {model.toUpperCase()} watch faces
      </Typography>
      <Stack
        direction="row"
        justifyContent="center"
        mb={4}
      >
	  { type !== 2 ?
			(<TextField
			  style={{ flex: 1 }}
			  className="search-box"
			  label="Search"
			  variant='filled'
			   defaultValue={searchText}
			  onChange={(e) => { setSearchText(e.target.value)
								 	}}
			/>)
		:
		(
			 <TextField
				  style={{ flex: 1 }}
				  id="selectsubject"
				  select				 
				  defaultValue={lang}
				 onChange={(e) => { setLang(e.target.value)
									 }}
				 
				>
			  {langlist.map((option) => (
				<MenuItem key={option.label} value={option.value} >
				  {option.label}
				</MenuItem>
			  ))}
			</TextField>
		)
		
	  }
        <Button 
        variant="contained"
        sx={{ ml: 2 }}
        onClick={fetchSearch}
         >
          <SearchIcon />
        </Button>
      </Stack>
      <Tabs
        value={type}
        indicatorColor='primary'
        textColor='primary'
        centered variant='fullWidth'
        sx={{ mb: 5 }}
        onChange={(event, newValue) => {
          setType(newValue);
          
		 
        }}
      >
        <Tab label="Search by Name"></Tab>
        <Tab label="Search by Author"></Tab>
		<Tab label="Search by Language"></Tab>
      </Tabs>
      <div className="card-grid">
        {
          content && content.map(item => {
            return <Card key={item.fileid} {...item} />
          })

        }
      </div>
      { ( content.length === 0) &&
        (type ?
          <Typography variant="h4" component="h4">No Watch Face Found</Typography> :
          <Typography variant="h4" component="h4">No Watch Face Found</Typography>
        )
      }
    </div>
  )
}

export default Search